// src/components/ProtectedRoute.js

// import { Navigate, useLocation } from "react-router-dom";

// const ProtectedRoute = ({ children }) => {
//   const token = localStorage.getItem("token");
//   const location = useLocation();

//   if (!token && location.pathname !== "/login" && location.pathname !== "/") {
//     return <Navigate to="/login" replace />;
//   }

//   return children;
// };


// export default ProtectedRoute;

import { Navigate, useLocation } from "react-router-dom";
import { isSignedIn } from "../utils/authStorage";
import { setPostLoginRedirect } from "../utils/postLoginRedirect";

const ProtectedRoute = ({ children }) => {
  // Task 149: there is no readable token. This is a UI guard only — it keeps
  // the applicant from landing on a page that would immediately fail; the API
  // authorises each request from the HttpOnly cookie regardless.
  const signedIn = isSignedIn();
  const location = useLocation();

  // ✅ Check URL for token param too
  const params = new URLSearchParams(window.location.search);
  const urlToken = params.get("token");

  // ✅ If NO token anywhere, redirect
  if (!signedIn && !urlToken && location.pathname !== "/login" && location.pathname !== "/") {
    // Stash the intended SPA path so Login / OAuthSuccess can redirect here after auth.
    setPostLoginRedirect(`${location.pathname}${location.search}`);
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;

